module.exports = __webpack_public_path__ + "static/media/crystals.ed3c5566.jpg";